// Debug utility to check auth state in localStorage
export const debugAuthState = () => {
  const token = localStorage.getItem('authToken');
  const user = localStorage.getItem('user');
  const tokenExpires = localStorage.getItem('tokenExpires');
  
  console.group('🔍 Auth Debug Information');
  console.log('Token present:', !!token);
  console.log('Token value:', token ? token.substring(0, 20) + '...' : 'null');
  console.log('User present:', !!user);
  console.log('User data:', user ? JSON.parse(user) : 'null');
  console.log('Token expires:', tokenExpires);
  
  if (tokenExpires) {
    try {
      const expirationDate = new Date(tokenExpires);
      const currentDate = new Date();
      console.log('Token expired:', currentDate >= expirationDate);
      console.log('Time until expiration:', expirationDate.getTime() - currentDate.getTime(), 'ms');
    } catch (error) {
      console.log('Error parsing expiration date:', error);
    }
  }
  
  console.log('All localStorage keys:', Object.keys(localStorage));
  console.groupEnd();
};

// Add to window for easy debugging
(window as any).debugAuth = debugAuthState;
